import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { type BookmarkMutationParams, useUpdateBookmark } from 'features/feed/queries/hooks';
import { bookmarkObject } from '../../services';

export const useBookmarkObjectMutation = () => {
  const updateCache = useUpdateBookmark();

  return useMutation<unknown, BookmarkMutationParams>({
    mutationFn: async (params) => bookmarkObject(params.type === 'node' ? params.event.id : params.contentObject.id),
    onSuccess(_, params) {
      updateCache(params);
    },
  });
};
